import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GmdashboardLinkComponent } from './gmdashboard-link/gmdashboard-link.component';
import { GmdashboardComponent } from './gmdashboard/gmdashboard.component';

const routes: Routes = [
  {
    path: '',
    component: GmdashboardLinkComponent,
    children: [
      { path: 'gmDashboard', component: GmdashboardComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GmDashboardRoutingModule { }
